import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserService } from "src/app/iap/services/user.service";
import { AuthenticationService } from "src/app/shared/auth/auth.service";
import { ClaimsTableComponent } from "./claims-table/claims-table.component";
import { MatCardModule } from "@angular/material/card";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-new-requests",
    templateUrl: "./new-requests.component.html",
    styleUrls: ["./new-requests.component.scss"],
    imports: [
        MatCardModule,
        ClaimsTableComponent,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule
    ]
})
export class NewRequestsComponent implements OnInit {
  public agencyID: string;
  public agencyName: string;
  @Output() eventClick: EventEmitter<any> = new EventEmitter();
  commissionsLocked: boolean = false;
  commissionsLockedMessage: string = "";

  @ViewChild(ClaimsTableComponent)
  private claimsTableComponent: ClaimsTableComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthenticationService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.commissionsLocked = true;
    this.userService.getCommissionLockedStatus().subscribe(result => {
      if (result) {
        this.commissionsLocked = result.commissionWindowStatus;
        this.commissionsLockedMessage = result.commissionWindowMessage;
      }
    });
    // add guard to not display the Commissions screen if you are not an agent
    if (
      this.authService.isAgencyAdmin() ||
      this.authService.isCommissionsUser()
    ) {
      let userInfo = this.authService.getUserInfo();

      this.userService.getAgentAndAgencyID(userInfo.oid).subscribe(
        result => {
          this.agencyID = result.AgencyID;

          // previous line commented and next one uncommented when running locally
          //this.agencyID = result.AgencyID;

          if (result.Company_Name) {
            this.agencyName = result.Company_Name;
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  onDispute(): void {
    let url = "iap/commissions/disputed-request-all/";
    this.router.navigate([url, this.agencyID]);
  }

  passEmit(event: any) {
    this.eventClick.emit({ loading: event.loading, term0: event.term0 });
  }

  refresh(tabParentValue: any) {
    if (tabParentValue) {
      this.claimsTableComponent.term0 = tabParentValue.term0;
      this.claimsTableComponent.term1 = tabParentValue.term1;
    }

    this.claimsTableComponent.refreshData(tabParentValue);
  }

  getSelectedTerm(): any {
    return this.claimsTableComponent.selectedTermOption;
  }
}
